import { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  Typography,
  Button,
  FormControl,
  Switch,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { writeOffAccount } from "API/swesum";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: 4,
  padding: 4,
  width: "100%",
  minWidth: 500,
  height: "100%",
};

export default function WriteOffAccountModal({
  account,
  open,
  onClose,
  fetchAccounts,
}) {
  const [reasonForDeduction, setReasonForDeduction] = useState("");
  const [debitClient, setDebitClient] = useState(false);
  const [loading, setLoading] = useState(false);
  const [onlyReminderFee, setOnlyReminderFee] = useState(false);
  const { openSuccess, openError } = usePopupNotificationContext();

  const handleConfirm = async () => {
    try {
      setLoading(true);

      const { data } = await writeOffAccount(account.InvoiceId, {
        endCustomerAccountId: account.Id,
        writeOffSource: debitClient ? 0 : 1,
        Description: reasonForDeduction,
        OnlyReminderFee: onlyReminderFee,
      });

      if (data.Status === "error") {
        openError(data.Message);
      } else {
        openSuccess(data.Message, 5000);
      }

      if (fetchAccounts) {
        await fetchAccounts();
      }
    } catch (error) {
      openError("Något gick fel under avksrivning");
    } finally {
      setLoading(false);
      onClose();
    }
  };

  useEffect(() => {
    setReasonForDeduction("");
    setDebitClient(false);
  }, [open]);

  return (
    <>
      <Dialog open={open}>
        <Box sx={style}>
          <Typography variant="h5" fontWeight={"bold"}>
            Vill du skriva av slutkundskontot?
          </Typography>
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            width={"100%"}
          >
            <FormControl fullWidth>
              <Box display="flex" gap={3} flexDirection="column">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={0}
                >
                  <Typography fontWeight={"medium"} fontSize={16}>
                    Nummer:
                  </Typography>
                  <Typography fontSize={16}>
                    {account?.InvoiceReference}
                  </Typography>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={0}
                >
                  <Typography fontWeight={"medium"} fontSize={16}>
                    Ursprungligt belopp:
                  </Typography>
                  <Typography fontSize={16}>{account?.Amount}</Typography>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={0}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography fontWeight={"medium"}>
                      Debitera klient
                    </Typography>
                    <Switch
                      value={debitClient}
                      onChange={(e) => setDebitClient(e.target.checked)}
                    />
                  </div>

                  {debitClient &&
                  account.EndCustomerArticle.Payrule !== "PÅMINNELSE1" &&
                  account.EndCustomerArticle.Payrule !== "PÅMINNELSE2" ? (
                    <FormControlLabel
                      style={{ marginRight: 0 }}
                      control={
                        <Checkbox
                          checked={onlyReminderFee}
                          onChange={(e) => setOnlyReminderFee(e.target.checked)}
                        />
                      }
                      label="Endast påminnelseavgift"
                    />
                  ) : null}
                </Box>
                <Box display={"flex"} flexDirection={"column"} width={"100%"}>
                  <Typography fontWeight={"medium"}>Anledning:</Typography>
                  <TextField
                    minRows={4}
                    placeholder="Notering"
                    multiline
                    value={reasonForDeduction}
                    onChange={(e) => setReasonForDeduction(e.target.value)}
                    style={{
                      minWidth: 450,
                      width: "100%",
                      borderRadius: 3,
                      border: "1px solid gray",
                    }}
                  />
                </Box>
              </Box>
            </FormControl>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={5}
            justifyContent={"space-around"}
            height={55}
            width={"100%"}
          >
            <Button
              sx={{
                backgroundColor: "transparent",
                outline: "1px solid #1976d2",
                color: "#1976d2",
                width: "100%",
              }}
              onClick={() => onClose()}
            >
              Avbryt
            </Button>
            <LoadingButton
              variant="contained"
              onClick={handleConfirm}
              loading={loading}
              sx={{
                backgroundColor: "#1976d2",
                color: "white",
                width: "100%",
              }}
            >
              Bokför
            </LoadingButton>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}
